import styled from 'styled-components';

export const VideoContainer = styled.div`
  position: relative;
  max-height: 0;
  width: 100%;
  padding-top: 56.25%;
  overflow: hidden;
`;

export const Iframe = styled.iframe.withConfig({
  shouldForwardProp: (prop) =>
    ![
      'allowFullscreen',
      'webkitallowfullscreen',
      'mozallowfullscreen',
      'msallowfullscreen',
      'oallowfullscreen',
      'allow',
    ].includes(prop),
})`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const OpenNewpage = styled.div`
  background: linear-gradient(75.34deg, #2e2e2e -1.51%, #4a4a4a 101.11%);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-top: 33px;
  color: ${(props) => props.theme.colors.white};
  text-align: center;

  svg {
    stroke: ${(props) => props.theme.colors.white};
  }
`;
